export const appVersion =
  process.env['REACT_APP_PACKAGE_VERSION'] || 'development'
export const appEnvironment = process.env['REACT_APP_ENVIRONMENT'] || 'local'
export const rumAuth = process.env['REACT_APP_RUM_AUTH'] || ''
export const ldClientId =
  process.env['REACT_APP_LAUNCHDARKLY_CLIENT_SIDE_ID'] || ''
